<template>
  <div>
    <div class="signin">
      <div class="center-content">
        <div class="login-form">
          <el-card>
            <img src="~styles/img/egslogo.png" alt />

            <div class="welcome-detail">
              <h1>Welcome Back</h1>
              <p>Plese enter your username and password to Login.</p>
            </div>

            <form class="content-form">
              <div class="form-group">
                <label for class="control-label">Username</label>
                <input
                  v-model="input.username"
                  name="username"
                  id="email"
                  type="text"
                  class="form-control"
                  placeholder
                  @keyup="loginerror = false"
                  autofocus
                />
              </div>
              <div class="form-group">
                <label for class="control-label">Password</label>
                <input
                  id="password"
                  name="password"
                  v-model="input.password"
                  v-on:keyup.enter="logItIn()"
                  placeholder
                  type="password"
                  @keyup="loginerror = false"
                  class="form-control"
                />
              </div>

              <transition name="fade">
                <p v-if="loginerror" class="text-danger input-error">Email ID or Password Incorrect.</p>
              </transition>

              <!-- <p class="text-danger">{{ loginerror }}</p> -->
              <div class="form-group">
                <button type="button" class="btn eg-btn" @click="logItIn">Login</button>
              </div>
            </form>
          </el-card>
        </div>

        <div class="discription">
          <img src="~styles/img/grow.png" alt />
          <h1>
            Grow Your Business With
            <br />
            <span>Engagement Management System</span>
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { loginUrl, getHeader } from "./../../config";
import { mapState } from "vuex";

const { detect } = require("detect-browser");
const browser = detect();

export default {
  name: "Login",
  computed: {
    ...mapState({
      userStore: state => state.userStore
    })
  },
  data() {
    return {
      loginerror: false,
      input: {
        username: "",
        password: ""
      }
    };
  },
  created() {
    // this.$store.dispatch('clearAuthUser')
    // window.sessionStorage.removeItem('authUser')
    // this.$router.push({name: 'login'})
    if (window.sessionStorage.getItem("authUser") !== null) {
      this.$router.push({ name: "dashboard" });
    }

    if (browser) {
      if (browser.name != "chrome") {
        this.$router.push({ name: "notsupported" });
      }
      // console.log(browser.name);
      // console.log(browser.version);
      // console.log(browser.os);
    }
  },
  methods: {
    logItIn() {
      const authUser = {};
      axios
        .post(loginUrl, this.input)
        .then(response => {
          if (response.status === 200) {
            // console.log(response);
            authUser.access_token = response.data.token;
            window.sessionStorage.setItem("authUser", JSON.stringify(authUser));
            this.$store.dispatch("setUserObject", authUser);
            this.$router.go({ name: "dashboard", force: true });
          } else {
            console.log(response);
          }
        })
        .catch(response => {
          // console.log("Emai or Password incorrect")
          this.loginerror = true;
          this.$notify({
            duration: 10000,
            group: "foo",
            type: "error",
            title: "Login failed",
            text: "Email ID or Password Incorrect"
          });
        });
    }
  }
};

// let token=response.data.token;

// localStorage.setItem('token',token);

// this.$router.push('/message');
</script>





// WEBPACK FOOTER //
// src/components/account/login.vue